import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/seo";
import { useLang } from "@/context/LanguageContext";

const pick = (v, lang) => {
  if (v == null) return "";
  if (typeof v === "string") return v;
  return v[lang] ?? v.es ?? "";
};

// Per-page bilingual SEO: title, meta, canonical, hreflang, Open Graph, Twitter, JSON-LD.
const Seo = ({ title, description, keywords, image, type = "website", jsonLd }) => {
  const { lang, basePath } = useLang();

  const T = pick(title, lang);
  const D = pick(description, lang);
  const K = pick(keywords, lang);

  const esUrl = SITE.domain + basePath;
  const enUrl = SITE.domain + (basePath === "/" ? "/en" : "/en" + basePath);
  const canonical = lang === "en" ? enUrl : esUrl;
  const img = image || SITE.ogImage;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{T}</title>
      <meta name="description" content={D} />
      {K && <meta name="keywords" content={K} />}

      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="es" href={esUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={esUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Grabarte" />
      <meta property="og:locale" content={lang === "en" ? "en_US" : "es_ES"} />
      <meta property="og:locale:alternate" content={lang === "en" ? "es_ES" : "en_US"} />
      <meta property="og:title" content={T} />
      <meta property="og:description" content={D} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={canonical} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={T} />
      <meta name="twitter:description" content={D} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
